//Set ahplabetic excel column according to given column quantity
export function numToSSColumn(quantity: number){
  var s = '', t;

  while (quantity > 0) {
    t = (quantity - 1) % 26;
    s = String.fromCharCode(65 + t) + s;
    quantity = (quantity - t)/26 | 0;
  }
  return s || undefined;
}
